<template>
  <DocumentLayout>
    <h1 class="my-10 text-center text-6xl font-bold">Terms of Service</h1>
    <p>
      Subject to these Terms of Service (this "Agreement"),
      <strong>AthleticNext.com</strong>. ("AthleticNext", "we", "us" and/or
      "our") provides access to AthleticNext's cloud platform, including,
      without limitation, this website, mobile applications, and certain APIs
      (collectively, the "Services"). By using or accessing the Services, you
      acknowledge that you have read, understand, and agree to be bound by this
      Agreement.
    </p>

    <p class="mt-8">
      <strong class="font-semibold"> Your Content. </strong><br />
      You are solely responsible for all data, information, feedback,
      suggestions, text, content, and other materials that you upload, post,
      deliver, provide or otherwise transmit or store (hereafter "post(ing)") in
      connection with or relating to the Services ("Your Content"). You are
      responsible for maintaining the confidentiality of usernames and passwords
      associated with your account and for all activities that occur under your
      account. AthleticNext reserves the right to access your account in order
      to respond to your requests for technical support. You further agree that
      AthleticNext may remove or disable any of Your Content at any time for any
      reason (including, but not limited to, upon receipt of claims or
      allegations from third parties or authorities relating to Your Content),
      or for no reason at all.
    </p>

    <div class="mt-8">
      <strong class="font-semibold">
        The customer has the following rights and obligations when entering this
        Agreement: </strong
      ><br />
      <ul class="ml-10 list-disc">
        <li>
          Access and rights to order modules on AthleticNext mobile apps and
          athleticnext.com website, as well as support through the channels that
          AthleticNext defines.
        </li>
        <li>
          Proprietary right to registered data. In case of termination of the
          customer relationship, the customer is entitled to export personal
          data to a machine-readable format.
        </li>
        <li>
          Access to new versions of the ordered modules under the validity of
          the agreement.
        </li>
        <li>
          The customer is obliged to use AthleticNext in accordance with good
          business practices.
        </li>
      </ul>
    </div>

    <div class="mt-8">
      <strong class="font-semibold"
        >AthleticNext has the following rights and obligations when entering
        into this Agreement:</strong
      ><br />
      <ul class="ml-10 list-disc">
        <li>
          Do not allow unauthorized and/or third parties access to sensitive
          accounting data about the customer except by statutory obligation.
        </li>
        <li>
          Right to make changes and upgrades in the system, athleticnext.com
          website, and mobile apps.
        </li>
        <li>
          Right to log and analyze usage patterns and data in order to offer
          increased functionality and improvements as long as anonymity is
          maintained. This means, for example, using a registered account for a
          supplier and suggesting it to new customers, as long as the initial
          registration cannot be traced.
        </li>
        <li>
          Right to change price and price model. If changes exceed the consumer
          price index, customers must be notified at least three months before
          this change is implemented.
        </li>
        <li>
          In the event of any errors or deficiencies in the system,
          AthleticNext's liability is limited to the amount the customers pay
          while using the system.
        </li>
        <li>
          In case of non-payment by customers, AthleticNext has the right to
          block access to its own services.
        </li>
        <li>
          Right to transport this agreement to a subsidiary or other limited
          company.
        </li>
      </ul>
    </div>

    <div class="mt-8">
      <strong class="font-semibold"> Contact details</strong><br />
      <ul>
        <li>
          An email is a valid form of communication in all aspects of this
          agreement. AthleticNext's e-mail address is always available at
          athleticnext.com.
        </li>
        <li>
          Customers’ e-mail addresses are the addresses that are registered on
          the AthleticNext's profile in the system. It is the customer's
          responsibility to update it.
        </li>
      </ul>
    </div>

    <div class="mt-8">
      <strong class="font-semibold">Privacy</strong><br />
      <ul>
        <li>
          Please visit
          <router-link
            :to="PUBLIC_ROUTES.PRIVACY_POLICY"
            class="font-semibold hover:underline"
          >
            https://athleticnext.com/legal/privacy
          </router-link>
          to understand how AthleticNext collects and uses personal information.
        </li>
      </ul>
    </div>
  </DocumentLayout>
</template>

<script setup lang="ts">
import DocumentLayout from 'src/components/layout/DocumentLayout.vue';
import { PUBLIC_ROUTES } from 'src/core/AppRoutes';
</script>
